<template>
    <CustomModal
        :is-modal-visible="updateVisible"
        :modal-title="'Chỉnh sửa cấu hình lịch đồng bộ cấp trường'"
        :close-function="closeModalUpdate"
        width="900px"
        :err-modal="errModal"
    >
        <template v-slot:content>
            <div>
                Hệ thống sẽ thực hiện thay đổi thời gian tiếp nhận dữ liệu của
                trường sau.
            </div>
            <div class="mt-3 mb-3">
                <div class="col-md-4 mb-3" style="padding-left: 0 !important">
                    <label class="label">Thời gian <span class="error-label">*</span></label>
                    <el-date-picker
                        v-model="date"
                        type="daterange"
                        start-placeholder="Từ ngày"
                        end-placeholder="Đến ngày"
                        size="medium"
                        format="dd/MM/yyyy"
                        @change="onChangeDateRange"
                    >
                    </el-date-picker>
                    <span
                        v-if="err_start_date.length > 0 || err_end_date.length > 0"
                        class="text-error-select"
                    >
                        {{ err_start_date || err_end_date }}
                    </span>
                </div>
            </div>
            <CustomTable :table-modal="true" :hide-pagi="true" :column-form="1" :hide-btn-table="true" style="border: none; padding: 0px; margin: 0;">
                <template v-slot:header>
                    <tr>
                        <th>STT</th>

                        <th>Tên trường</th>
                        <th>Mã trường</th>
                    </tr>
                </template>
                <template v-slot:body>
                    <tr v-for="(item, index) in dataUpdate" :key="index">
                        <td>
                            {{ index + 1 }}
                        </td>
                        <td class="text-left">{{ item.tenTruongHoc }}</td>
                        <td>{{ item.maTruongHoc }}</td>
                    </tr>
                </template>
            </CustomTable>
        </template>

        <template v-slot:btn-handle>
            <CustomButton label="Cập nhật" @click="handleUpdate" />
        </template>
    </CustomModal>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import CustomModal from '@/components/CustomModal.vue'
import { showNotication } from '@/utils/notification'
import CustomTable from '@/components/CustomTable.vue'
import { formatDateToDDMMYYYY, formatDateToYYYYMMDD } from '@/utils'
import { validateFields, handlerError } from '@/utils/validator'
export default {
    name: 'ModalUpdate',
    data() {
        return {
            date: '',
            start_date: '',
            end_date: '',
            err_end_date: '',
            err_start_date: '',
            errModal: false
        }
    },
    components: { CustomButton, CustomModal, CustomTable },
    props: {
        updateVisible: {
            type: Boolean,
            required: true
        },
        dataUpdate: {
            type: Array,
            required: true
        },

        closeModalUpdate: Function,
        handleSearch: Function
    },
    watch: {
        dataUpdate(newVal) {
            if (newVal.length === 1) {
                const start_date = newVal.map((item) => item.tuNgay)
                this.start_date = formatDateToYYYYMMDD(start_date)
                const end_date = newVal.map((item) => item.denNgay)
                this.end_date = formatDateToYYYYMMDD(end_date)
                if (this.start_date && this.end_date) {
                    this.date = [this.start_date, this.end_date]
                }
            } else {
                this.start_date = ''
                this.end_date = ''
                this.date = ''
            }
        }
    },
    methods: {
        onChangeDateRange(value) {
            if (value && value.length === 2) {
                this.start_date = value[0]
                this.end_date = value[1]
                this.onChangeHandler('start_date', value[0])
                this.onChangeHandler('end_date', value[1])
            } else {
                this.start_date = ''
                this.end_date = ''
                this.err_start_date = ''
                this.err_end_date = ''
                this.errModal = false
            }
        },
        onChangeHandler(source, newValue) {
            const errorFields = {
                start_date: 'err_start_date',
                end_date: 'err_end_date'
            }

            handlerError(this, source, newValue, errorFields)

            if (source in errorFields) {
                handlerError(this, source, newValue, errorFields)

                this.errModal = !!newValue || !!this[errorFields[source]]
            } else {
                this.errModal = !!newValue
            }
        },
        async handleUpdate() {
            try {
                const fieldsToValidate = [
                    {
                        value: this.start_date,
                        errorField: 'err_start_date'
                    },
                    {
                        value: this.end_date,
                        errorField: 'err_end_date'
                    }
                ]
                if (validateFields(this, fieldsToValidate)) {
                    const dsMaTruong = this.dataUpdate.map(
                        (item) => item.maTruongHoc
                    )

                    const request_data = {
                        tuNgay: formatDateToDDMMYYYY(this.start_date),
                        denNgay: formatDateToDDMMYYYY(this.end_date),
                        statusUpdate: this.statusUpdate,
                        dsMaTruong: dsMaTruong,
                        maSo: this.auth_user.ma_so,
                        namHoc: this.selectedYearFromStore
                    }
                    const response = await sendRequest(
                        Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo
                            .thay_doi_ngay_cap_truong,
                        request_data,
                        this.request_headers,
                        null
                    )
                    if (response.rc == 0) {
                        showNotication(this, 'success', 'Cập nhật thành công', {
                            customClass: 'notification-unlock'
                        })
                        this.closeModalUpdate()
                        this.$emit('handleSearch')
                    } else {
                        showNotication(
                            this,
                            'warning',
                            'Cập nhật không thành công',
                            {
                                customClass: 'notification-lock'
                            }
                        )
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    mounted() {},
    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },
        selectedGradeLevelFromStore() {
            return this.$store.state.gradeLevel.gradeLevel
        },
        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped>
::v-deep .el-input__inner {
    border: 1px solid #b2b7bd;
}
::v-deep .el-input__inner {
    color: #373333;
}

::v-deep .el-input__inner:focus {
    border: 1px solid #007bff;
    box-shadow: #b2b7bd;
}

.el-date-table td.start-date span,
.el-date-table td.end-date span {
    background-color: var(--blue-200);
}
.el-date-table td.today span,
.el-date-table td.available:hover {
    color: var(--blue-200);
}
</style>
